module.exports = __webpack_public_path__ + "media/pdf_missing/osobowy-5c459070.svg";